<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					zIndex: {
						name: 'zIndex',
						defaultValue: '',
						labelDesc: 'zIndex',
						callback: function () {
							vm.resources.zIndex.defaultValue = this.value;
							vm.element.internal_config.zIndex = this.value;

						},
					},
          maxWidth: {
            name: 'maxWidth',
            defaultValue: '500',
            min: '200',
            max: '768',
            labelDesc: 'max-width-tablet',
            callback: function () {
              vm.resources.maxWidth.defaultValue = this.value;
              vm.element.internal_config.maxWidth = this.value + 'px';

            },
          },
					sbFacebook: {
						name: 'sbFacebook',
						defaultValue: '',
						labelDesc: 'Facebook',
						canRemove: false,
						callback: function () {
							vm.resources.sbFacebook.defaultValue = this.value;
							vm.element.internal_config.sbFacebook = this.value;
						},
					},
					sbTwitter: {
						name: 'sbTwitter',
						defaultValue: '',
						labelDesc: 'Twitter',
						canRemove: false,
						callback: function () {
							vm.resources.sbFacebook.defaultValue = this.value;
							vm.element.internal_config.sbTwitter = this.value;
						},
					},
					sbInstagram: {
						name: 'sbInstagram',
						defaultValue: '',
						labelDesc: 'Instagram',
						canRemove: false,
						callback: function () {
							vm.resources.sbInstagram.defaultValue = this.value;
							vm.element.internal_config.sbInstagram = this.value;
						},
					},
					sbNewAba: {
						name: 'sbNewAba',
						defaultValue: '',
						labelDesc: 'NewAba',
						canRemove: false,
						callback: function () {
							vm.resources.sbNewAba.defaultValue = this.value;
							vm.element.internal_config.sbNewAba = this.value;
						},
					},
					sbLinkedin: {
						name: 'sbLinkedin',
						defaultValue: '',
						labelDesc: 'Linkedin',
						canRemove: false,
						callback: function () {
							vm.resources.sbLinkedin.defaultValue = this.value;
							vm.element.internal_config.sbLinkedin = this.value;
						},
					},
					checkFacebook: {
						name: 'checkFacebook',
						defaultValue: '',
						labelDesc: 'Show-Facebook',
						callback: function () {

							vm.resources.checkFacebook.defaultValue = this.value
							vm.element.internal_config.checkFacebook = this.value;

						},
					},
					checkTwitter: {
						name: 'checkTwitter',
						defaultValue: '',
						labelDesc: 'Show-Twitter',
						callback: function () {
							vm.resources.checkTwitter.defaultValue = this.value
							vm.element.internal_config.checkTwitter = this.value

						}
					},
					checkInstagram: {
						name: 'checkInstagram',
						defaultValue: '',
						labelDesc: 'Show-Instagram',
						callback: function () {

							vm.resources.checkInstagram.defaultValue = this.value
							vm.element.internal_config.checkInstagram = this.value;

						},
					},
					checkLinkedin: {
						name: 'checkLinkedin',
						defaultValue: '',
						labelDesc: 'Show-Linkedin',
						callback: function () {
							vm.resources.checkLinkedin.defaultValue = this.value
							vm.element.internal_config.checkLinkedin = this.value

						}
					},
                    orientation:{
					  name: 'orientation',
                      defaultValue: false,
                      labelDesc: 'Show-orientation',
                      callback: function ()
                      {
                        vm.resources.orientation.defaultValue = this.value;
                        vm.element.internal_config.orientation = this.value;

                        let orientation = vm.element.internal_config.orientation;
                        let width = parseInt(vm.element.internal_config.width);

                        width = orientation ? width / 3 : width * 3

                        vm.element.internal_config.width = width + 'px';


                      }
                    },
					imageFacebook:{
						name: 'imageFacebook',
						defaultValue: '',
            			showOptions : false,
						labelDesc: 'img-facebook',
						canRemove: true,
						callback: function () {

							vm.resources.imageFacebook.defaultValue = this.imageSelected;
							vm.element.internal_config.imageFacebook = this.imageSelected;
							vm.element.rebuild();
						}
					},
					imageTwitter:{
						name: 'imageTwitter',
						defaultValue: '',
            			showOptions : false,
						labelDesc: 'img-twitter',
						canRemove: true,
						callback: function () {

							vm.resources.imageTwitter.defaultValue = this.imageSelected;
							vm.element.internal_config.imageTwitter = this.imageSelected;
							vm.element.rebuild();
						}
					},
					imageInstagram:{
						name: 'imageInstagram',
						defaultValue: '',
            			showOptions : false,
						labelDesc: 'img-instagram',
						canRemove: true,
						callback: function () {

							vm.resources.imageInstagram.defaultValue = this.imageSelected;
							vm.element.internal_config.imageInstagram = this.imageSelected;
							vm.element.rebuild();
						}
					},
					imageLinkedin:{
						name: 'imageLinkedin',
						defaultValue: '',
						labelDesc: 'img-linkedin',
            			showOptions : false,
						canRemove: true,
						callback: function () {

							vm.resources.imageLinkedin.defaultValue = this.imageSelected;
							vm.element.internal_config.imageLinkedin = this.imageSelected;
							vm.element.rebuild();
						}
					},
          spaceBetween: {
						name: 'spaceBetween',
						defaultValue: '0',
						labelDesc: 'spaceBetween',
						callback: function () {
							vm.resources.spaceBetween.defaultValue = this.value
							vm.element.internal_config.spaceBetween = this.value;
						},
					},
					width: {
						name: 'width',
						defaultValue: '300',
						min: '50',
						max: '1000',
						labelDesc: 'width',
						callback: function () {
							vm.resources.width.defaultValue = this.value;
							vm.element.internal_config.width = this.value + 'px';
						},
					},
					border: {
						name: 'border',
						defaultValue: '1px solid black',
						min: '0',
						max: '50',
						labelDesc: 'border',
						callback: function () {
							let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

							vm.resources.border.defaultValue = value;
							vm.element.internal_config.border = value;
						},
					},
					borderRadius: {
						name: 'borderRadius',
						defaultValue: '0 0 0 0',
						min: '0',
						max: '360',
						labelDesc: 'borderRadius',
						callback: function () {

							let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

							vm.resources.borderRadius.defaultValue = value;
							vm.element.internal_config.borderRadius = value;
						},
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '50',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},
				}
			}
		},
    methods: {
      setMinValuesData(resource, value) {
        this.resources[resource].min = parseInt(value);
      },
      setValuesData(data) {
        this.element = data;
        this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

        this.resources.imageFacebook.defaultValue = data.internal_config.imageFacebook;
        this.resources.imageTwitter.defaultValue = data.internal_config.imageTwitter;
        this.resources.imageInstagram.defaultValue = data.internal_config.imageInstagram;
        this.resources.imageLinkedin.defaultValue = data.internal_config.imageLinkedin;

        this.resources.sbFacebook.defaultValue = data.internal_config.sbFacebook;
        this.resources.sbTwitter.defaultValue = data.internal_config.sbTwitter;
        this.resources.sbInstagram.defaultValue = data.internal_config.sbInstagram;
        this.resources.sbNewAba.defaultValue = data.internal_config.sbNewAba;
        this.resources.sbLinkedin.defaultValue = data.internal_config.sbLinkedin;

        this.resources.spaceBetween.defaultValue = data.internal_config.spaceBetween;
        this.resources.orientation.defaultValue = data.internal_config.orientation;

        this.resources.checkFacebook.defaultValue = data.internal_config.checkFacebook;
        this.resources.checkTwitter.defaultValue = data.internal_config.checkTwitter;
        this.resources.checkInstagram.defaultValue = data.internal_config.checkInstagram;
        this.resources.checkLinkedin.defaultValue = data.internal_config.checkLinkedin;

        this.resources.width.defaultValue = parseInt(data.internal_config.width);
        this.resources.border.defaultValue = data.internal_config.border;
        this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
        this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
        this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
        this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
        this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
      },
      getValuesData() {
        return this.resources;
      }
    },
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/SocialBar/Resources.vue